<template>
  <b-nav-item v-bind:class="activeLocation" v-on:click="emitLocation(location.id)">
    {{ location.name }}
	</b-nav-item>
</template>
<script>
export default {
  name: 'LocationList',
  props: ['location', 'selectedlocatid'],
  data () {
    return {
      isActive: true
    }
  },

  computed: {
      activeLocation: function() {
          if (this.selectedlocatid == this.location.id) {
            return { active: this.isActive }
          } else {
            return { active: false }
          }
      }
  },

  methods: {
    emitLocation(locatid) {
      this.$emit('locatemit', locatid);
    }
  }
}
</script>

<style>



</style>
